export default {
    search: "請輸入使用說明信息",
    nomore: "暫無更多",
}